import * as BrandIcons from './brand';
import * as DuotoneIcons from './duotone';
import * as LightIcons from './light';
import * as SolidIcons from './solid';
import * as RegularIcons from './regular';

export default [DuotoneIcons, SolidIcons, BrandIcons, LightIcons, RegularIcons];
